import { IDiscountTagProps } from './DiscountTag.types';
import { useDiscountTagStyles } from './DiscountTag.styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTag } from '@fortawesome/free-solid-svg-icons/faTag';

const DiscountTag = (props: IDiscountTagProps) => {
    const styles = useDiscountTagStyles();

    return (
        <div className={styles.root}>
            <FontAwesomeIcon icon={faTag} className={styles.tagIcon} />

            {props.taglines.length === 1 && (
                <div className={styles.singleMessage}>
                    <div dangerouslySetInnerHTML={{ __html: props.taglines[0] }}></div>
                </div>
            )}

            {props.taglines.length > 1 && (
                <div className={styles.messageList}>
                    <ul>
                        {props.taglines.map((t) => (
                            <li key={t} dangerouslySetInnerHTML={{ __html: t }}></li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default DiscountTag;
